import {
  recognitionCardsService,
  CreateRecognitionCardRequest,
  RecognitionCardItem,
} from '@aslanpay/portal-common-lib';
import { useMutation } from '@tanstack/react-query';

const useRecognitionCardMutations = () => {
  const createCard = useMutation<RecognitionCardItem, Error, CreateRecognitionCardRequest>((body) =>
    recognitionCardsService.createRecognitionCard(body)
  );

  const deleteCard = useMutation<unknown, Error, string>((cardId) =>
    recognitionCardsService.deleteRecognitionCard(cardId)
  );

  return { createCard, deleteCard };
};

export default useRecognitionCardMutations;
